import { useCurrentUser } from "../actions/CurrentUserActions";
import {
  ACCEPTED_FILE_TYPES,
  ACCEPTED_VIDEO_FILE_TYPES,
  ESV2_ACCEPTED_AUDIO_FILE_TYPES,
  NATIVELY_ACCEPTED_AUDIO_FILE_TYPES,
} from "../constants/AcceptedFiles";

export const useStudioAcceptedFileTypes = (
  videoOnly: boolean = false
): string => {
  const { currentUser } = useCurrentUser();
  const hasStudioVideoUploadEnabled = Boolean(
    currentUser?.studioVideoUploadEnabled
  );
  const hasStudioConvertedAudioUploadEnabled = Boolean(
    currentUser?.studioConvertedAudioUploadEnabled
  );

  if (hasStudioVideoUploadEnabled) {
    return videoOnly ? ACCEPTED_VIDEO_FILE_TYPES : ACCEPTED_FILE_TYPES;
  }

  if (hasStudioConvertedAudioUploadEnabled) {
    return ESV2_ACCEPTED_AUDIO_FILE_TYPES;
  }

  return NATIVELY_ACCEPTED_AUDIO_FILE_TYPES;
};
